<script setup lang="ts">
/*
 * Reusable empty-state block — icon + title + description + action slot.
 * Centered, padded, in a card-like container. Used when a list/table has
 * no data or a filter returned zero rows.
 */
defineProps<{
  title: string;
  description?: string;
}>();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center rounded-3xl border border-dashed border-app-border bg-app-surface px-8 py-12 text-center"
  >
    <div
      class="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-500"
    >
      <slot name="icon" />
    </div>
    <h3 class="text-base font-semibold text-app-fg">{{ title }}</h3>
    <p v-if="description" class="mt-1 max-w-md text-md text-app-muted">{{ description }}</p>
    <div v-if="$slots.action" class="mt-6">
      <slot name="action" />
    </div>
  </div>
</template>
